import * as React from "react"
import { App } from "./app"
import { BDKalkCore } from "./BDKalkCore"
import { BuildPartGW } from "./BuildPartGW"

///////////////   BuildPartSaveView  ////////////////

/* BuildPartaveView is displayed when the user has requested to save the current buildpart. */

export interface BuildPartSaveViewVm  {
    app: App
}

export interface BuildPartSaveViewStateVm {
    stage: string
}

export class BuildPartSaveView extends React.Component<BuildPartSaveViewVm, BuildPartSaveViewStateVm> {
    state = {
        stage: "initial"
    }

    constructor(props: BuildPartSaveViewVm) {
        super(props)
        this.m_name = ""
        this.m_overwriteBuildPartContentOccurances = new Array<BuildPartGW>()
        this.m_overwriteProjectContentOccurances = new Array<BuildPartGW>()
    }

    componentWillMount() {
        this.props.app.GetCore().ConnectBuildPartSaveView(this)
    }

    OnConvert() {
        this.props.app.GetCore().ConvertArticleAmounts()
        this.OnSave()
    }
    
    OnSave() {
        if (this.m_byggdelName != null) {
            this.m_name = this.m_byggdelName.value
        }

        var externalAmounts = this.props.app.GetCore().ConvertArticleAmountOccuranceCollect(false)

        if (externalAmounts.length > 0) {
            this.setState({ stage: "convertQuestion" })
            return
        }

        if (this.props.app.GetCore().GetSelectionSetManager().HasPreviouslySavedBuildPartName(this.m_name) == true) {
            /* The build part is already saved with the given name. This leads to more than one potential risk, which
               will be dealt with accordingly.

               1: The user might not really want to overwrite the previous build part with the same name
               2: A buildpart with the same name might be one of the build parts directly or indirectly
                  included by the build part being saved, causing a hierarchial loop, which must be avoided!
               3: Other build parts might have the earlier version of the build part with same name as their
                  included build parts, so overwriting it might lead to unwanted surprises within those build parts

               To counter these potential issues the following will happen
               1: The user is asked if he/she really wants to overwrite the previous version of the build part
               2: A hierarchial loop will be detected and if spotted, the save will be stopped and the user informed
               3: Whenever other build parts or saved selections are effected by an overwrite, the user will be
                  informed about this, with the occurrances enlisted, and be given the following options:
                  A: Cancel the buildpart saving process
                  B: Let the new version of the saved buildpart replace the old one in all the occurances   
            */

            // Detecting a hierarchial loop:
            var allBP = this.props.app.GetCore().GetBuildParts()
            var allProj : BuildPartGW[] = this.props.app.GetCore().GetProjectSummaries()
            var name = this.m_name
            var selBP = this.props.app.GetCore().GetSelectedBuildParts()

            var HierarchyLoopFound = false
            for (var i = 0; i < selBP.length; i++) {
                if (this.BrowseForHierarchyLoop(name, selBP[i]) == true) {
                    HierarchyLoopFound = true
                    break
                }
            }

            if (HierarchyLoopFound == true) {
                this.setState({ stage: "hierarchyLoopFound" })
                return
            }

            // Next we'll detect occurances within other build parts or saved selections of a build part with the same title as being saved
            var occurancesBP = new Array<BuildPartGW>()
            var occurancesUtvalg = new Array<BuildPartGW>()

            // Finding occurances among buildparts:
            for (var i = 0; i < allBP.length; i++) {
                if (allBP[i].GetTitle() == name) {
                    continue // Ignoring the overwritten build part itself
                }

                for (var j = 0; j < allBP[i].GetIncludedBuildParts().length; j++){
                    if (this.BrowseForHierarchyLoop(name, allBP[i].GetIncludedBuildParts()[j].ref) == true) {
                        occurancesBP.push(allBP[i])
                        break
                    }
                }
            }
            
            // Finding occurances among saved projects:
            for (var i = 0; i < allProj.length; i++) {
                for (var j = 0; j < allProj[i].GetIncludedBuildParts().length; j++) {

                    if (this.BrowseForHierarchyLoop(name, allProj[i].GetIncludedBuildParts()[j].ref) == true) {
                        occurancesUtvalg.push(allProj[i])
                        break
                    }
                }
            }
            
            if ((occurancesBP.length > 0) || (occurancesUtvalg.length > 0)) {
                this.m_overwriteBuildPartContentOccurances = occurancesBP
                this.m_overwriteProjectContentOccurances = occurancesUtvalg
                this.setState({ stage: "occurancesFoundInOtherBuildparts" })
                return
            }
            
            this.setState({ stage: "overwriteQuestion" })
        }
        else {
            this.OnSaveSure()
        }
    }

    BrowseForHierarchyLoop(bannedName: string, searchedBP: BuildPartGW) {
        if (searchedBP.GetTitle() == bannedName) {
            return true
        }

        var foundLoop = false

        // Recursion to find indirect occurances of the "forbidden" title
        for (var i = 0; i < searchedBP.GetIncludedBuildParts().length; i++) {
            if (this.BrowseForHierarchyLoop(bannedName, searchedBP.GetIncludedBuildParts()[i].ref) == true) {
                return true
            }
        }

        return false
    }

    OnSavePreSureOld() {
        this.m_name = this.m_byggdelName.value
        this.OnSaveSure()
    }

    OnSaveSure() {
        this.props.app.GetCore().GetSelectionSetManager().SaveBuildPart(this.m_name)
        this.setState({ stage: "confirmingSave" })
    }
    
    OnCansel() {
        this.props.app.setState({ DisplayMode: this.props.app.DMode.QReport })
    }

    OnOK() {
        this.props.app.setState({ DisplayMode: this.props.app.DMode.QReport })
    }

    SetFocus() {
        if (this.m_byggdelName != null) {
            this.m_byggdelName.value = this.props.app.GetCore().GetSelectionSetManager().GetCurrentBuildPartName()
            setTimeout(this.SetFocusFulfill.bind(this), 80)
        }
    }

    SetFocusFulfill() {
        var buildPartNameInput = document.getElementById("BuildPartNameInput")
        buildPartNameInput && buildPartNameInput.focus()
    }

    render() {

        // Initial stage: Lagre prosjekt som... [input]
        if (this.state.stage == "initial") {
            setTimeout(this.SetFocus.bind(this), 150)

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{width:"calc(50% - 50px)", height:"1px"}}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Lagre bygningsdel som..</div>
                    <input
                        id="BuildPartNameInput"
                        type="text"
                        ref={(input) => { if (input != null) this.m_byggdelName = input }}
                        style={{ width: "150px", height: "35px", position: "relative", top: "9px" }}>
                    </input>
                    <div onClick={this.OnSave.bind(this)} style={{ backgroundColor: "grey", width: "64px", height: "30px", position: "relative", top: "20px", cursor: "pointer"}}>
                        <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor:"pointer" }}>
                            Lagre
                        </div>
                    </div>
                </div>
            </div>
        }

        // Checks if the user wants to overwrite a saved buildPart with the identical name
        if (this.state.stage == "overwriteQuestion") {
            setTimeout(this.SetFocus.bind(this), 150)

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Ær du sikker på at du vil</div>
                    <div>overskrive den tidligere</div>
                    <div>bygningsdelen med samme</div>
                    <div>navn?</div>

                    <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                        <div onClick={this.OnSaveSure.bind(this)} style={{ backgroundColor: "grey", width: "64px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Lagre
                            </div>
                        </div>

                        <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left:"20px",cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Avbryt
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        // Checks if the user wants to overwrite a saved buildPart with the identical name
        if (this.state.stage == "occurancesFoundInOtherBuildparts") {
            setTimeout(this.SetFocus.bind(this), 150)

            var elementsBP: Array<JSX.Element> | null = new Array<JSX.Element>()
            elementsBP.push(<div key={"main0"} style={{ height: "20px" }}></div>)
            elementsBP.push(<div key={"main1"}>Bygningsdeler som blir påvirket ved overskrivning er:</div>)

            var key = 0
            for (var i = 0; i < this.m_overwriteBuildPartContentOccurances.length; i++) {
                const keyStr = (key++).toString()
                elementsBP.push(<div key={keyStr} style={{color:"red"}}>{this.m_overwriteBuildPartContentOccurances[i].GetTitle()}</div>)
            }

            if (elementsBP.length < 3) {
                elementsBP = null
            }

            var elementsPro: Array<JSX.Element> | null = new Array<JSX.Element>()
            elementsPro.push(<div key={"main0"} style={{ height: "20px" }}></div>)
            elementsPro.push(<div key={"main1"}>Utvalg som blir påvirket ved overskrivning er:</div>)
            
            for (var i = 0; i < this.m_overwriteProjectContentOccurances.length; i++) {
                const keyStr = (key++).toString()
                elementsPro.push(<div key={keyStr} style={{ color: "red" }}>{this.m_overwriteProjectContentOccurances[i].GetTitle()}</div>)
            }

            if (elementsPro.length < 3) {
                elementsPro = null
            }

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Det finns allerede en bygningsdel med samme navn.</div>
                    <div>Denne bygningsdelen er inkludert i andre bygningsdeler</div>
                    <div>eller i utvalg. Hvis du overskriver denne bygningsdelen</div>
                    <div>vil dette påvirke de andre bygningsdelene og utvalgene.</div>
                    <div>Hvis du ikke ønsker dette, klikk Avbryt og lagre</div>
                    <div>deretter bygningsdelen med et annet navn.</div>
                    {elementsBP}
                    {elementsPro}

                    <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                        <div onClick={this.OnSaveSure.bind(this)} style={{ backgroundColor: "grey", width: "90px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Overlagre
                            </div>
                        </div>

                        <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Avbryt
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        }

        // Checks if the user wants to convert custom selections of supplier/package into default settings
        if (this.state.stage == "convertQuestion") {
            setTimeout(this.SetFocus.bind(this), 150)

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Utvalget inneholder valg av leverandør</div>
                    <div>eller pakketype som ikke er standard.</div>
                    <div>Dine valg må omregnes til standardenheter</div>
                    <div>før du kan lagre bygningsdelen, vil du</div>
                    <div>gjøre det nå?</div>
                    
                    <div style={{ position: "relative", top: "5px", display: "flex", flexDirection: "row" }}>
                        <div onClick={this.OnConvert.bind(this)} style={{ backgroundColor: "grey", width: "90px", height: "30px", position: "relative", top: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Omregne
                            </div>
                        </div>

                        <div onClick={this.OnCansel.bind(this)} style={{ backgroundColor: "grey", width: "74px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                            <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                                Avbryt
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        }
        
        // Checks if the user wants to overwrite a saved buildPart with the identical name
        if (this.state.stage == "hierarchyLoopFound") {
            setTimeout(this.SetFocus.bind(this), 150)

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column"}}>
                    <div style={{ color: "red" }}>ADVARSEL: Bygningsdelen ble ikke lagret!</div>
                    <div>Den nye bygningsdelen kan ikke ha samme tittel </div>
                    <div>som underliggende bygningsdeler.</div>

                    <div onClick={this.OnOK.bind(this)} style={{ backgroundColor: "grey", width: "44px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                        <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                            OK
                        </div>
                    </div>
                </div>
            </div>
        }

        // Checks if the user wants to overwrite a saved BuildPart with the identical name
        if (this.state.stage == "confirmingSave") {
            setTimeout(this.SetFocus.bind(this), 150)

            return <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "calc(50% - 50px)", height: "1px" }}>
                </div>
                <div style={{ position: "relative", top: "80px", display: "flex", flexDirection: "column" }}>
                    <div>Din bygningsdel ær nå lagret.</div>

                    <div onClick={this.OnOK.bind(this)} style={{ backgroundColor: "grey", width: "44px", height: "30px", position: "relative", top: "20px", left: "20px", cursor: "pointer" }}>
                        <div style={{ position: "relative", top: "6px", left: "12px", color: "white", cursor: "pointer" }}>
                            OK
                        </div>
                    </div>
                </div>
            </div>
        }

        return <div>(save BuildPart view)</div>
    }

    private m_overwriteBuildPartContentOccurances: Array<BuildPartGW>
    private m_overwriteProjectContentOccurances: Array<BuildPartGW>
    private m_byggdelName: HTMLInputElement
    private m_name:string // Keeps the name from the input as the imput gets unmounted due to changing display into showing overvrite question
}



// WEBPACK FOOTER //
// ./client/view/BuildPartSaveView.tsx